import { Users, ShieldCheck, Clock, Terminal, Wifi, Smartphone } from "lucide-react";

function Stat({ icon: Icon, label, value, accent, testid }) {
  return (
    <div className="card-surface card-hover p-5 flex items-center gap-4" data-testid={testid}>
      <div className={`w-12 h-12 rounded-md flex items-center justify-center ${accent}`}>
        <Icon size={22} />
      </div>
      <div>
        <div className="text-2xl font-heading font-bold leading-none">{value}</div>
        <div className="text-xs text-muted-foreground mt-1">{label}</div>
      </div>
    </div>
  );
}

export default function DashboardView({ stats, status }) {
  const st = status || {};
  return (
    <div className="space-y-6">
      <div>
        <span className="overline text-gold">Resumen general</span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold">Dashboard</h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat testid="stat-groups" icon={Users} label="Grupos totales" value={stats.totalGroups ?? 0} accent="bg-gold/15 text-gold" />
        <Stat testid="stat-active" icon={ShieldCheck} label="Licencias activas" value={stats.activeLicenses ?? 0} accent="bg-emerald-500/15 text-emerald-400" />
        <Stat testid="stat-expired" icon={Clock} label="Expiradas" value={stats.expiredLicenses ?? 0} accent="bg-crimson/15 text-crimson" />
        <Stat testid="stat-commands" icon={Terminal} label="Comandos ejecutados" value={stats.commandsRun ?? 0} accent="bg-blue-500/15 text-blue-400" />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="card-surface p-6 lg:col-span-1" data-testid="whatsapp-connection-card">
          <span className="overline text-gold">Conexión WhatsApp</span>
          <h3 className="text-xl font-heading font-semibold mb-4">Estado del Bot</h3>
          {st.state === "ready" ? (
            <div className="flex flex-col items-center text-center py-6">
              <div className="w-16 h-16 rounded-full bg-emerald-500/15 flex items-center justify-center mb-4">
                <Wifi className="text-emerald-400" size={30} />
              </div>
              <div className="text-emerald-400 font-bold text-lg">Conectado</div>
              <div className="flex items-center gap-2 mt-2 text-muted-foreground">
                <Smartphone size={16} />
                <span className="font-mono">+{st.number || "—"}</span>
              </div>
            </div>
          ) : st.state === "qr" && st.qr ? (
            <div className="flex flex-col items-center text-center">
              <p className="text-sm text-muted-foreground mb-4">
                Escanea este código desde WhatsApp → Dispositivos vinculados
              </p>
              <div className="bg-white p-3 rounded-md border-4 border-gold/20">
                <img data-testid="qr-code-image" src={st.qr} alt="QR" className="w-52 h-52" />
              </div>
              <p className="text-xs text-muted-foreground mt-4 font-mono">Número bot: +50555023717</p>
            </div>
          ) : (
            <div className="flex flex-col items-center text-center py-10 text-muted-foreground">
              <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4">
                <Wifi size={30} />
              </div>
              <div className="font-medium capitalize">{st.state || "offline"}</div>
              <p className="text-xs mt-2">Esperando conexión del bot…</p>
            </div>
          )}
        </div>

        <div
          className="card-surface p-6 lg:col-span-2 relative overflow-hidden"
          style={{
            backgroundImage:
              "linear-gradient(rgba(18,18,20,.92),rgba(18,18,20,.96)), url('https://images.unsplash.com/photo-1728577379969-768bf0747172?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200')",
            backgroundSize: "cover",
          }}
        >
          <span className="overline text-gold">Tu clan, tu legado</span>
          <h3 className="text-2xl font-heading font-bold mb-2">Bienvenido a AC WARDEN</h3>
          <p className="text-muted-foreground text-sm max-w-lg mb-6">
            Gestiona múltiples grupos de WhatsApp, cada uno vinculado a su clan de Clash of Clans.
            Controla licencias, avisos de ataques y reportes de guerra desde un solo lugar.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
            {[
              ["Datos 100% actualizados", "bg-gold/10 text-gold"],
              ["Avisos en tiempo real", "bg-emerald-500/10 text-emerald-400"],
              ["Reportes CWL", "bg-blue-500/10 text-blue-400"],
              ["Rankeds global y local", "bg-purple-500/10 text-purple-400"],
              ["Rival CWL", "bg-crimson/10 text-crimson"],
              ["Plan Elite $2.99", "bg-gold/10 text-gold"],
            ].map(([t, c]) => (
              <div key={t} className={`rounded-md px-3 py-2 ${c}`}>{t}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
